var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgNoiseSuppressionOff = function SvgNoiseSuppressionOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.062 5.26a.83.83 0 00-.229.573v8.334a.833.833 0 001.667 0v-7.47L6.062 5.26zm3.105 3.104v8.303a.833.833 0 001.666 0V10.03L9.167 8.364zm4.135 4.135a.833.833 0 01-.801-.8l.8.8zm.865-1.53L12.5 9.302v-.969a.833.833 0 011.667 0v2.636zm3.324 3.324l-1.658-1.657V5.833a.833.833 0 011.667 0v8.334a.831.831 0 01-.01.126zm-6.658-6.657L9.167 5.969V3.333a.833.833 0 011.666 0v4.303zm-7.5-.136a.833.833 0 00-.833.833v3.334a.833.833 0 001.667 0V8.333a.833.833 0 00-.834-.833z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.915 1.915a.847.847 0 011.198 0l14.972 14.972a.847.847 0 11-1.198 1.198L1.915 3.113a.847.847 0 010-1.198z",
    fill: "#fff"
  })));
};

export default SvgNoiseSuppressionOff;